import { Controller } from '../utils/controller';
import * as focusTrap from 'focus-trap';

export default class extends Controller {
  static targets = ['focusTrap'];
  static requiredTargets = [];

  static values = {
    focusTrap: Boolean
  };

  // TARGETS
  declare focusTrapTarget: HTMLElement;
  declare hasFocusTrapTarget: boolean;

  focusTrap;

  initialize() {
    if (this.hasFocusTrapTarget) {
      const options = {
        initialFocus: this.initialFocus(),
        clickOutsideDeactivates: true
      };

      this.focusTrap = focusTrap.createFocusTrap(this.focusTrapTarget, options);

      this.focusTrap.activate();
    }
  }

  disconnect() {
    if (this.hasFocusTrapTarget && this.focusTrap) {
      this.focusTrap.deactivate();
    }
  }

  initialFocus() {
    return this.focusTrapTarget.children.length
      ? this.focusTrapTarget.children[0]
      : this.focusTrapTarget;
  }
}
